import { useQuery } from 'react-query';
import axios from 'axios';
import { useContext } from 'react';
import { AuthContext } from '../../Context/AuthContext';

const useCustomerOrders = (customerId) => {
  const { token } = useContext(AuthContext);

  return useQuery(
    ['customerOrders', customerId],
    async () => {
      const response = await axios.get(
        `${process.env.REACT_APP_SERVER_URL}/order/orders/customer/${customerId}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      return response.data.orders;
    },
    { enabled: !!customerId && !!token }
  );
};

export default useCustomerOrders;
